<template>
  <div class="ai-score-detail">
    <div class="score-header">
      <div class="score-header-top">
        <span class="total-score">总分：{{ aiScore.score }}</span>
        <a-button v-if="isReset" size="small" type="primary" @click="$emit('reset')">重新打分</a-button>
      </div>

      <div class="score-reason">{{ aiScore.reason }}</div>
    </div>
    <a-divider style="margin: 12px 0" />
    <div class="score-details">
      <div v-for="(detail, index) in aiScore.details" :key="index" class="detail-item">
        <div class="detail-header">
          <span class="detail-type">{{ detail.type }}</span>
          <span class="detail-score" :class="getScoreClass(detail.score)">{{ detail.score }}</span>
        </div>
        <div class="detail-reason">{{ detail.reason }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AiScoreViewDetail',
  props: {
    aiScore: {
      type: Object,
      required: true
    },
    isReset: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getScoreClass(score) {
      if (score >= 4) {
        return 'score-high';
      } else if (score >= 2) {
        return 'score-medium';
      } else {
        return 'score-low';
      }
    }
  }
};
</script>

<style lang="less" scoped>
.ai-score-detail {
  //   width: 500px;
  max-height: 800px;
  overflow-y: auto;

  .score-header {
    .score-header-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
    }

    .total-score {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 8px;
      display: block;
    }

    .score-reason {
      color: rgba(0, 0, 0, 0.65);
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .score-details {
    .detail-item {
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }

      .detail-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 4px;

        .detail-type {
          font-weight: 500;
        }

        .detail-score {
          padding: 0 8px;
          border-radius: 10px;
          font-size: 12px;

          &.score-high {
            background: #f6ffed;
            color: #52c41a;
          }

          &.score-medium {
            background: #fff7e6;
            color: #fa8c16;
          }

          &.score-low {
            background: #fff1f0;
            color: #f5222d;
          }
        }
      }

      .detail-reason {
        color: rgba(0, 0, 0, 0.65);
        font-size: 13px;
        line-height: 1.5;
      }
    }
  }
}
</style>
